import 'src/utils/polyfills';

import invariant from 'invariant';
import React from 'react';
import {createRoot} from 'react-dom/client';

import {bootstrapSentry} from 'src/client/bootstrap-sentry';
import {bootstrapStores} from 'src/client/bootstrap';

import ErrorBoundary from 'src/components/500/boundary';
import SchedulerApp from 'src/components/scheduler/app';


const {reduxStore, store, env} = bootstrapStores();
bootstrapSentry(env);

const appElement = document.getElementById('app');

invariant(appElement, 'Could not render without an #app.');

const [_empty, _scheduler, agentId, templateSuffix] =
  window.location.pathname.split('/');

const root = createRoot(appElement);
root?.render(
  <ErrorBoundary>
    <SchedulerApp
      agentId={agentId}
      templateSuffix={templateSuffix}
      reduxStore={reduxStore}
      senseStore={store}
      env={env.serverRuntimeEnvironment}
    />
  </ErrorBoundary>,
);
